import { Datipreventivo } from "../model/datipreventivo";
import { Lead } from "../model/lead";

export class DatiSpecial {
    public static dati(): Datipreventivo {
        return {
            id_comodity: 5,
            lead: new Lead(),
            component:null,
            datiextra: [
                {
                    idDato: 1,
                    tipodato: 1, //string
                    lstopzione: [],
                    descrizione: "consumo annuo",
                    valore: "0"
                },
                {
                    idDato: 2,
                    tipodato: 2, //list
                    lstopzione: [
                        {
                            value: "1",
                            des: "1",
                            urlfoto: ""
                        },
                        {
                            value: "2",
                            des: "2",
                            urlfoto: ""
                        },
                    ],
                    descrizione: "Numero Componenti",
                    valore: "0"
                },
            ]

        };
    }
}




// WEBPACK FOOTER //
// ./src/app/archiviodatipreventivo/dati-special.ts